var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { BaseService } from '../types/index.js';
import { sleep } from '@portkey/utils';
const DefaultQueryOptions = {
    interval: 5000,
    reCount: 0,
    maxCount: 20,
};
const searchMethod = 'GET';
export class Search extends BaseService {
    getChainsInfo() {
        return __awaiter(this, void 0, void 0, function* () {
            const req = yield this._request.send({
                method: searchMethod,
                url: '/api/app/search/chainsinfoindex',
            });
            return req.items;
        });
    }
    getRegisterStatus(id, options = JSON.parse(JSON.stringify(DefaultQueryOptions))) {
        return __awaiter(this, void 0, void 0, function* () {
            if (options.reCount > options.maxCount)
                throw new Error('timeout');
            const req = yield this._request.send({
                method: searchMethod,
                url: '/api/app/search/accountregisterindex',
                params: {
                    filter: `_id:${id}`,
                },
            });
            const result = req.items[0];
            if (!result || result.registerStatus === 'pending') {
                yield sleep(options.interval);
                return this.getRegisterStatus(id, Object.assign(Object.assign({}, options), { reCount: ++options.reCount }));
            }
            return result;
        });
    }
    getRecoverStatus(id, options = JSON.parse(JSON.stringify(DefaultQueryOptions))) {
        return __awaiter(this, void 0, void 0, function* () {
            if (options.reCount > options.maxCount)
                throw new Error('timeout');
            const req = yield this._request.send({
                method: searchMethod,
                url: '/api/app/search/accountrecoverindex',
                params: {
                    filter: `_id:${id}`,
                },
            });
            const result = req.items[0];
            if (!result || result.recoveryStatus === 'pending') {
                yield sleep(options.interval);
                return this.getRecoverStatus(id, Object.assign(Object.assign({}, options), { reCount: ++options.reCount }));
            }
            return result;
        });
    }
    getCAHolderInfo(Authorization, caHash) {
        return __awaiter(this, void 0, void 0, function* () {
            const req = yield this._request.send({
                headers: { Authorization },
                method: searchMethod,
                url: '/api/app/search/caholderindex',
                params: {
                    filter: `caHash: ${caHash}`,
                },
            });
            return req.items[0];
        });
    }
}
